module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/922310d46a823ad4a24968f5a8ab1fdc.png";